import { find, findIndex, groupBy, map, keys, reverse, sortBy, omitBy, isNil, startCase, toLower } from "lodash";

export const generateCategoryTree = (categories: any) => {
  if (!categories.length) return;

  let categoryGroupLevel = groupBy(sortBy(categories,'level'),'level') // {1:[], 2:[]}
  let resultArray:any[] = [];
  let categoryKeys = reverse(keys(categoryGroupLevel));

  map(categoryKeys, key => {
    if (parseInt(key) >= 1) {
      const parentKey = `${parseInt(key) - 1}`;

      map(categoryGroupLevel[key], cat => {
        const foundIndex = findIndex(categoryGroupLevel[parentKey], o => o._id === cat.parent);
        const parentObj = find(categoryGroupLevel[parentKey], o => o._id === cat.parent);

        if (foundIndex >= 0) {
          categoryGroupLevel[parentKey].splice(foundIndex, 1, {
            ...parentObj,
            children: [ ...(parentObj?.children || []),
              omitBy({
                value: cat._id,
                label: startCase(toLower(cat.name)),
                children: cat.children
              }, isNil)
            ]
          })
        }

        // Store all level 2 parent
        if (parentObj && !parentObj.parent) {
          const foundIndex = findIndex(resultArray, o => o.value === parentObj._id);
          const data = omitBy({
            value: parentObj._id,
            label: startCase(toLower(parentObj.name)),
            children: parentObj.children
          }, isNil)

          if (foundIndex >= 0)
            resultArray.splice(foundIndex, 1, data)
          else
            resultArray.push(data)
        }

        // Store all level 1 category without children
        if (!parentObj) {
          const foundIndex = findIndex(resultArray, o => o.value === cat._id);
          const data = omitBy({
            value: cat._id,
            label: startCase(toLower(cat.name)),
            children: cat.children
          }, isNil)

          if (foundIndex >= 0)
            resultArray.splice(foundIndex, 1, data)
          else
            resultArray.push(data)
        }
      })
    }
  })

  return resultArray;
}
